import React from 'react'

const Header = ({children, title, description, buttonText, btnOnlcick, subTitle="", className="", ...props }) => {
  return (
    <div className={`flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-0 mb-4 sm:mb-8 ${className}`}>
      <div>
        <div className='flex flex-row justify-start items-center gap-2'>
          <h3 className="text-base sm:text-lg md:text-xl lg:text-2xl font-semibold">{title}</h3>
          {subTitle && <h5 className='text-[8px] sm:text-[10px] md:text-xs bg-purple-200 font-bold text-purple-800 px-2 sm:px-3 py-[2px] rounded-xl'>{subTitle}</h5>}
        </div>
        <p className="text-xs sm:text-sm md:text-base text-gray-500">{description}</p>
      </div>
      <div className='flex flex-row gap-2 mt-2 sm:mt-0'>
        {children && children}
        {buttonText && (
          <button 
            onClick={btnOnlcick} 
            className="text-xs sm:text-sm md:text-base bg-purple-600 text-white py-1 sm:py-2 px-3 sm:px-4 rounded-md hover:bg-purple-700 focus:outline-none"
          >
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default Header